import {ChangeDetectorRef, Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {KeyValuePipe, NgClass} from '@angular/common';
import {MatchUpService} from '@services/matchup.service';
import {environment} from '@/environments/environment';
import {MatchupStatus} from '@/app/core/models/bet/matchupStatus';
import {Matchup} from '@/app/core/models/bet/matchup';
import {BetSidebarComponent} from '@/app/pages/bet/bet-sidebar/bet-sidebar.component';
import {LeaderboardService} from '@services/leaderboard.service';
import {SeasonService} from '@services/season.service';
import {Season} from '@/app/core/models/bet/season';
import {LeaderboardEntry} from '@/app/core/models/bet/leaderboardEntry';
import {CurrentSeasonComponent} from '@/app/pages/bet/current-season/current-season.component';
import {TopFiveComponent} from '@/app/pages/bet/top-five/top-five.component';
import {BetHeaderComponent} from '@/app/pages/bet/bet-header/bet-header.component';
import {BetMatchupSkeletonComponent} from '@/app/pages/bet/bet-matchup-skeleton/bet-matchup-skeleton.component';
import {BetMatchupCardComponent} from '@/app/pages/bet/bet-matchup-card/bet-matchup-card.component';
import {
	BetFinishedMatchupCardComponent
} from '@/app/pages/bet/bet-finished-matchup-card/bet-finished-matchup-card.component';
import {Prediction} from '@/app/core/models/bet/prediction';
import {PredictionService} from '@services/prediction.service';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {LocalizedWeekendRangePipe} from '@/app/shared/pipes/localizedWeekendRange.pipe';
import {IsBetPlacedPipe} from '@/app/shared/pipes/isBetPlaced.pipe';
import {GetUserBetPipe} from '@/app/shared/pipes/getUserBet.pipe';
import {AuthService} from '@services/auth.service';
import {Title} from '@angular/platform-browser';

@Component({
	selector: 'peps-bet',
	imports: [
		TranslatePipe,
		NgClass,
		BetSidebarComponent,
		CurrentSeasonComponent,
		TopFiveComponent,
		BetHeaderComponent,
		BetMatchupSkeletonComponent,
		BetMatchupCardComponent,
		BetFinishedMatchupCardComponent,
		KeyValuePipe,
		LocalizedWeekendRangePipe,
		IsBetPlacedPipe,
		GetUserBetPipe,
	],
	templateUrl: './bet.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './bet.component.css'
})
export class BetComponent implements OnInit {

	constructor(
		private readonly matchupService: MatchUpService,
		private readonly leaderboardService: LeaderboardService,
		private readonly seasonService: SeasonService,
		private readonly predictionService: PredictionService,
		private readonly authService: AuthService,
		private readonly cdr: ChangeDetectorRef,
		private readonly titleService: Title,
		private readonly translate: TranslateService
	) {}

	isBetSidebarOpen = false;

	selectedTab: MatchupStatus = 'SCHEDULED'
	selectedMatchup: Matchup | null = null;
	isSeasonOngoing: boolean = false;
	currentPrediction: Prediction | null = null;

	matchups: Record<MatchupStatus, Record<string, Matchup[]>> = {
		SCHEDULED: {},
		FINISHED: {}
	};

	currentSeason: Season | null = null;
	top5Leaderboard: LeaderboardEntry[] = [];
	userPredictions: Prediction[] = [];

	minioBaseUrl = environment.minioBaseUrl;

	ngOnInit(): void {
		this.titleService.setTitle(this.translate.instant('page.bet.title'));
		this.loadCurrentSeason();
		this.loadMatchUpsOfCurrentSeason();
		if(this.authService.isAuthenticated()){
			this.loadUserPredictions();
		}
	}

	loadUserPredictions(): void {
		this.predictionService.getPredictionsByUser().subscribe({
			next: (data) => {
				this.userPredictions = data;
			},
			error: (err) => {
				console.error('Error loading user predictions', err);
			}
		});
	}

	loadMatchUpsOfCurrentSeason(): void {
		this.matchupService.getMatchupsBySeason().subscribe({
			next: (data) => {
				this.matchups = data;
			},
			error: (err) => {
				console.error('Error loading matchups', err);
			}
		});
	}

	selectMatchup(matchup: Matchup) {
		this.selectedMatchup = matchup;
		this.isBetSidebarOpen = true;
		this.currentPrediction = this.userPredictions.find(p => p.matchup.id === matchup.id) || null;
		this.cdr.detectChanges();
	}

	closeBetSidebar() {
		this.isBetSidebarOpen = false;
		this.selectedMatchup = null;
	}

	selectTab(status: MatchupStatus) {
		this.selectedTab = status;
	}

	loadCurrentSeason() {
		this.seasonService.getCurrentSeason().subscribe({
			next: (season) => {
				this.currentSeason = season;
				if (season) {
					this.loadTop5Leaderboard();
					this.isSeasonOngoing = true;
				}
			},
			error: (err) => {
				console.error('Error loading current season', err);
				this.currentSeason = null;
				this.isSeasonOngoing = false;
			}
		});

	}

	loadTop5Leaderboard() {
		if (!this.currentSeason) {
			this.top5Leaderboard = [];
			return;
		}

		this.leaderboardService.getTop5LeaderboardBySeason(this.currentSeason.year).subscribe({
			next: (entries) => {
				this.top5Leaderboard = entries;
			},
			error: (err) => {
				console.error('Error loading top 5 leaderboard', err);
				this.top5Leaderboard = [];
			}
		});
	}

	onBetValidated() {
		this.loadMatchUpsOfCurrentSeason();
		this.loadUserPredictions();
	}
}
